import { db } from "../firebase";
import { addDoc, collection, deleteDoc, doc, getDocs, updateDoc } from "firebase/firestore";
import { langNgheFirestore } from "../lib/langNgheFirestore";

function taoCrud(tenCollection) {
  const col = () => collection(db, tenCollection);

  return {
    async danhSach() {
      const snap = await getDocs(col());
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },
    langNgheDanhSach(onChange, onError) {
      return langNgheFirestore(col(), { onChange, onError });
    },
    async taoMoi(data) {
      const ref = await addDoc(col(), data);
      return { id: ref.id, ...data };
    },
    async capNhat(id, data) {
      await updateDoc(doc(db, tenCollection, id), data);
      return { id, ...data };
    },
    async xoa(id) {
      await deleteDoc(doc(db, tenCollection, id));
    },
  };
}

const loaiBoCrud = taoCrud("loaiBo");
const hinhThucTtCrud = taoCrud("hinhThucThanhToan");

export const danhMucApi = {
  loaiBo: () => loaiBoCrud.danhSach(),
  langNgheLoaiBo: (onChange, onError) => loaiBoCrud.langNgheDanhSach(onChange, onError),
  taoLoaiBo: (tenLoai) => loaiBoCrud.taoMoi({ tenLoai }),
  suaLoaiBo: (id, tenLoai) => loaiBoCrud.capNhat(id, { tenLoai }),
  xoaLoaiBo: (id) => loaiBoCrud.xoa(id),

  hinhThucThanhToan: () => hinhThucTtCrud.danhSach(),
  langNgheHinhThucThanhToan: (onChange, onError) =>
    hinhThucTtCrud.langNgheDanhSach(onChange, onError),
  taoHinhThucTt: (tenHinhThuc) => hinhThucTtCrud.taoMoi({ tenHinhThuc }),
  suaHinhThucTt: (id, tenHinhThuc) => hinhThucTtCrud.capNhat(id, { tenHinhThuc }),
  xoaHinhThucTt: (id) => hinhThucTtCrud.xoa(id),
};
